/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
/* eslint-disable functional/no-conditional-statement */
import { DynamicObject } from "../../address/hooks/useGetEmailFromToken";

export function setStyleProperties(
  element?: HTMLElement | null,
  styleProps?: DynamicObject
) {
  if (element && styleProps) {
    Object.keys(styleProps).forEach((key) => {
      // params for value is <string | null> type not <string | undefined> type
      element.style.setProperty(key, styleProps[key] ?? null);
    });
  }
}
